import { FieldWrapper, InputText } from '@dixa/lib-shared-habla';

import { useCopy } from 'utils/useCopy';

type TokenFieldTemplateProps = {
  value: string;
  label: string;
};

export const TokenFieldTemplate = ({
  value,
  label,
}: TokenFieldTemplateProps): JSX.Element => {
  const [copyToClipboard, copyState] = useCopy();

  return (
    <FieldWrapper label={label}>
      <InputText
        readOnly
        value={value}
        suffix={{
          type: 'button',
          button: {
            icon: copyState.status === 'copied' ? 'done' : 'copy',
            onClick: () => copyToClipboard(value),
          },
        }}
      />
    </FieldWrapper>
  );
};
